/* Grid with mobile slider */
import 'slick-carousel';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

export function grid_with_mobile_slider() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--grid-with-mobile-slider' ).length <= 0 ) {
				return;
			}

			$( '.block--grid-with-mobile-slider' ).each( ( i, e ) => {
				const slider = $( e ).find( '.cards' );

				slider.slick( {
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					mobileFirst: true,
					dots: true,
					arrows: false,
					responsive: [
						{
							breakpoint: 992,
							settings: "unslick"
						}
					]
				} );
			} );
		}

		init();
		// $( window ).on( 'resize', init );

		const intro_animation = () => {

			if ( $( window ).width() < 992 ) {
				return;
			}

			$( '.block--grid-with-mobile-slider' ).each( ( i, e1 ) => {

				let timeline = gsap.timeline( {
					scrollTrigger: {
						trigger: e1,
						start: "center bottom",
						// end: "bottom bottom",
						// scrub: true
					}
				} );
	
				$( e1 ).find( '.card' ).each( ( i, e2 ) => {
					gsap.set( e2, {
						opacity: 0,
						y: 100
					} );

					timeline.to( e2, {
						opacity: 1,
						y: 0
					}, "<15%" );
				} );

			} );

		}

		intro_animation();

	} )( window.jQuery );
}